import serv3 from '../assets/consult1.webp';
import Footer from './Footer';


export default function OHSConsulting() {
  return (
    <div className='md:mt-[10px] mt-[100px]'>
      <img
          src={serv3}
          alt="Hero Image"
          className="w-full h-[200px] md:h-[500px] object-cover"
        />
   
      
      
     <div className="bg-white p-12 text-center bg-inspiration-geometry">
      <h2 className="text-4xl font-maiandra mb-4">Strategic OHS Consulting Services</h2>
        <p className="text-gray-700 lg:ml-[34%] md:ml-[15%] font-myraid max-w-lg"><b>Mission: </b>To provide tailored, strategic, and technical advisory services to enhance workplace safety, compliance, and risk management for both private and public sector organizations.</p>
    
        <br></br><br></br> <br></br><br></br>

        <h2 className="text-4xl  font-maiandra mb-4">What We Do</h2> <br></br>
        <ul className="list-none md:pl-10 mb-6 text-left text-gray-700 space-y-2">
  <li className="flex items-start pl-6">
    <span className="mr-2 text-black text-xl">•</span>
    Risk Assessment & Safety Audits: Conduct in-depth assessments to identify workplace hazards and recommend mitigation measures.
  </li>
  <li className="flex items-start pl-6">
    <span className="mr-2 text-black text-xl">•</span>
    OHS Management Systems: Design and implement custom OHS systems in line with international frameworks such as ISO 45001.
  </li>
  <li className="flex items-start pl-6">
    <span className="mr-2 text-black text-xl">•</span>
    Regulatory Compliance: Assist clients in navigating local and international safety regulations to ensure full compliance with Rwandan labor laws and industry standards.
  </li>
  <li className="flex items-start pl-6">
    <span className="mr-2 text-black text-xl">•</span>
    Training & Capacity Building: Develop safety training programs that empower organizations to maintain safe working conditions.
  </li>
  <li className="flex items-start pl-6">
    <span className="mr-2 text-black text-xl">•</span>
    Incident Investigation & Response Planning: Provide expert advice on accident investigations and help develop emergency response plans.
  </li>
</ul>

        <br></br><br></br> <br></br><br></br>
      <div className="p-1 md:p-8 ">
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div className="bg-gray-900 p-6 text-white rounded-lg shadow-lg mb-8">
        <h2 className="text-2xl font-maiandra mb-4">Best Practices</h2>
        <ul className="list-none pl-0 mb-6 text-left text-gray-100 space-y-1">
  <li className="flex items-start pl-2">
    <span className="mr-2 text-white text-xl">•</span>
    Utilizing globally recognized frameworks and methodologies like ISO 45001 for Occupational Health and Safety Management Systems.

    </li>
    <li className="flex items-start pl-2">
    <span className="mr-2 text-white text-xl">•</span>Collaborating with government agencies, regulatory bodies, and international partners to deliver top-tier OHS consulting.</li>
    <li className="flex items-start pl-2">
    <span className="mr-2 text-white text-xl">•</span>Employing a continuous improvement approach in all client engagements to ensure sustained OHS performance.</li>
        </ul>
      </div>

      <div  className="bg-gray-900  p-6 rounded-lg shadow-lg mb-8" >
        <h2 className="text-2xl font-maiandra text-white mb-4">Key Strengths</h2>
        <ul className="list-none pl-0 mb-6 text-left text-gray-100 space-y-1">
           <li className="flex items-start pl-2">
    <span className="mr-2 text-white text-xl">•</span>Expertise in both local and global occupational safety standards.</li>
    <li className="flex items-start pl-2">
    <span className="mr-2 text-white text-xl">•</span>Focus on capacity building and long-term safety culture development.</li>
    <li className="flex items-start pl-2">
    <span className="mr-2 text-white text-xl">•</span>Ability to provide strategic, actionable insights for OHS improvement.</li>
        </ul>
      </div>
      </div>  <br></br><br></br>
    </div>
    </div>
  
    <Footer />
    </div>
  );
}
